import script from "./NewVersionAutomationDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewVersionAutomationDialog.vue?vue&type=script&setup=true&lang=ts"

import "./NewVersionAutomationDialog.vue?vue&type=style&index=0&id=6c02b1cf&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c02b1cf"]])